<div class="title">
  <h5>File Schedules</h5>
  <div class="addbtn">
    <button mat-button type="button" (click)="addClientFileInfo()" *ngIf="!this.Readonly">
      <div class="btnicon">
        <fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
      </div>
      <div class="btntext">Add File Schedule</div>
    </button>
  </div>
</div>
<div formArrayName="clientfilescheduleiInfolist">
  <div *ngFor="let fileschedule of fileschedules.controls; let i = index;">
    <mat-accordion>
      <mat-expansion-panel [expanded]="(FileSchedule_step===i)" (opened)="setFileScheduleStep(i)">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <fa-icon icon="file-alt" id="file-alt" class="fa-lg" matTooltipPosition="above"></fa-icon>
            {{i+1}}
          </mat-panel-title>
          <mat-panel-description>
            <div *ngIf="HasDescription_FileSchedule(i)">
              {{ GetDescription(fileschedules.controls[i].get('clientfileinfoid').value)}}</div>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div [formGroupName]="i" novalidate>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>File Descriptions</mat-label>
            <mat-select formControlName="clientfileinfoid" (selectionChange)="filedescriptionselected($event)">
              <mat-option *ngFor="let filedescription of filedescriptions" [value]="filedescription.id">
                {{filedescription.description}}</mat-option>
            </mat-select>
            <mat-error
              *ngIf="fileschedules.controls[i].get('clientfileinfoid').hasError('required') || !HasDescription_FileSchedule(i)">
              Please select file description.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Expected Start Time</mat-label>
            <input matInput placeholder="Expected Start Time" aria-label="24hr format" data-lpignore="true"
              formControlName="expectedstarttime" [ngxTimepicker]="startTime" [format]="24" readonly>
            <ngx-material-timepicker #startTime></ngx-material-timepicker>
          </mat-form-field>

          <mat-form-field class="col-md-2" appearance="outline">
            <mat-label>Expected Time Cron</mat-label>
            <input matInput placeholder="Min Hour DoM Mth DoW" type="text" data-lpignore="true"
              formControlName="expectedtime">
          </mat-form-field>

          <mat-form-field class="col-md-6" appearance="outline">
            <mat-label>Expected Time Description</mat-label>
            <input matInput placeholder="Expected Time Description" type="text" data-lpignore="true"
              formControlName="expectedtimetext">
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Expected Reset Time</mat-label>
            <input matInput placeholder="Expected Reset Time" aria-label="24hr format" data-lpignore="true"
              formControlName="expectedresettime" [ngxTimepicker]="resetTime" [format]="24" readonly>
            <ngx-material-timepicker #resetTime></ngx-material-timepicker>
            <mat-error *ngIf="fileschedules.controls[i].get('expectedresettime').hasError('timeerror')">
              Expected Reset Time should be before the Expected Start Time
            </mat-error>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline" *ngIf="processstatuses">
            <mat-label>Process Status</mat-label>
            <mat-select formControlName="processstatusid" (selectionChange)="processstatusesselected($event)">
              <mat-option *ngFor="let processstatus of processstatuses[i]" [value]="processstatus.id">
                {{processstatus.description}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>File Status</mat-label>
            <mat-select formControlName="filestatusid" (selectionChange)="fileStatussselected($event)">
              <mat-option *ngFor="let filestatuse of filestatuses" [value]="filestatuse.id">{{filestatuse.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Urgency</mat-label>
            <mat-select formControlName="urgency" (selectionChange)="filedescriptionselected($event)">
              <mat-option *ngFor="let urgency of urgencys" [value]="urgency.id">{{urgency.description}}</mat-option>
            </mat-select>
            <mat-error *ngIf="fileschedules.controls[i].get('urgency').hasError('required')">
              Please select urgency.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Impact</mat-label>
            <mat-select formControlName="impact" (selectionChange)="filedescriptionselected($event)">
              <mat-option *ngFor="let impact of impacts" [value]="impact.id">{{impact.description}}</mat-option>
            </mat-select>
            <mat-error *ngIf="fileschedules.controls[i].get('impact').hasError('required')">
              Please select impact.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Number of Files Expected</mat-label>
            <input matInput placeholder="Number of Files Expected" autocomplete="id" type="number"
              formControlName="numberoffilesexpected" min="0">
            <!--<mat-error *ngIf="fileschedules.controls[i].get('numberoffilesexpected').hasError('required')">
              Please enter number of files expected.
            </mat-error>-->
            <!--<mat-error *ngIf="fileschedules.controls[i].get('numberoffilesexpected').hasError('min')">
              Please enter number greater than -1
            </mat-error>-->
          </mat-form-field>

          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Expected Value for File Timeout</mat-label>
            <input matInput placeholder="Expected Value for File Timeout" aria-label="24hr format" data-lpignore="true"
              formControlName="filenamechecktime" [ngxTimepicker]="FilenameTimeout" [format]="24" readonly>
            <ngx-material-timepicker #FilenameTimeout></ngx-material-timepicker>
          </mat-form-field>

          <div>
            <mat-checkbox class="col-md-3" formControlName="runonsun">Run on Sun</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runonmon">Run on Mon</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runontue">Run on Tue</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runonwed">Run on Wed</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runonthu">Run on Thu</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runonfri">Run on Fri</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="runonsat">Run on Sat</mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="col-md-3" formControlName="createemail">Create Email</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="isemailpriority">Is Email Priority</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="createincident">Create Incident</mat-checkbox>
            <mat-checkbox class="col-md-3" formControlName="isenabled">Enable</mat-checkbox>
          </div>
        </div>

        <div class="deletebtn" *ngIf="i>-1">
          <button mat-button type="button" (click)="removeClientFileInfo(i)" *ngIf="!this.Readonly">
            <div class="btnicon">
              <fa-icon icon="minus" id="minus" class="fa-lg" matTooltipPosition="above"></fa-icon>
            </div>
            <div class="btntext">Delete File Schedule</div>
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
